import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { api } from "@/lib/api";
import { ArrowLeft, Copy, Hash, Link2, Inbox, AlertTriangle } from "lucide-react";
import { DuplicatesTab } from "@/components/clientmaster/DuplicatesTab";
import { ClientIdsTab } from "@/components/clientmaster/ClientIdsTab";
import { XeroLinksTab } from "@/components/clientmaster/XeroLinksTab";
import { UnmatchedTab } from "@/components/clientmaster/UnmatchedTab";
import { XeroChangesTab } from "@/components/clientmaster/XeroChangesTab";

const TABS = [
  ["dupes", "Duplicates", Copy, "duplicate_pairs"],
  ["ids", "Client IDs", Hash, "without_id"],
  ["xero", "Xero Links", Link2, "suggested_links"],
  ["unmatched", "Unmatched Invoices", Inbox, "unmatched_invoices"],
  ["changes", "Xero Changes", AlertTriangle, "xero_changes"],
];

export default function ClientMaster() {
  const [tab, setTab] = useState("dupes");
  const [sum, setSum] = useState(null);
  const refresh = () => api.get("/client-master/summary").then((r) => setSum(r.data)).catch(() => {});
  useEffect(() => { refresh(); }, []);

  return (
    <div className="p-8 md:p-10" data-testid="client-master-page">
      <Link to="/clients" className="text-xs text-[var(--ink-2)] hover:text-[var(--ink)] flex items-center gap-1 mb-3" data-testid="cmaster-back"><ArrowLeft size={12} /> Back to clients</Link>
      <div className="overline mb-2">Clients · Master list · Admin</div>
      <h1 className="font-display text-4xl mb-2">Data cleansing.</h1>
      <p className="text-sm text-[var(--ink-2)] mb-6 max-w-3xl">Practice-OS is the master client list. Clean up duplicates, issue Client IDs, and keep each client mapped to one Xero contact.</p>
      <div className="border-b border-[var(--line)] flex gap-6 mb-6 overflow-x-auto">
        {TABS.map(([key, label, Icon, cnt]) => (
          <button key={key} data-testid={`cmaster-tab-${key}`} onClick={() => setTab(key)}
            className={`py-2 flex items-center gap-2 border-b-2 -mb-px whitespace-nowrap ${tab === key ? "border-[var(--navy)] text-[var(--ink)]" : "border-transparent text-[var(--ink-2)] hover:text-[var(--ink)]"}`}>
            <Icon size={14} strokeWidth={1.5} /><span className="text-sm">{label}</span>
            {sum && sum[cnt] > 0 && <span className="text-[10px] font-mono-data px-1.5 rounded-sm bg-[var(--gold-soft)] text-[var(--ink)]" data-testid={`cmaster-count-${key}`}>{sum[cnt]}</span>}
          </button>
        ))}
      </div>
      {tab === "dupes" && <DuplicatesTab onChange={refresh} />}
      {tab === "ids" && <ClientIdsTab summary={sum} onChange={refresh} />}
      {tab === "xero" && <XeroLinksTab onChange={refresh} />}
      {tab === "unmatched" && <UnmatchedTab onChange={refresh} />}
      {tab === "changes" && <XeroChangesTab onChange={refresh} />}
    </div>
  );
}
